import { extract, Decoration_Type } from '@wix/ricos';
import { isDefined } from '../../ts-utils';
import { MentionType } from '../common-enums';
export const extractMentions = (content) => {
    return extract(content.nodes)
        .filter((n) => !!n.textData?.decorations.length)
        .map((n) => n.textData?.decorations?.filter((decoration) => decoration.type === Decoration_Type.MENTION && decoration.mentionData?.id))
        .get()
        .flat()
        .map((mention) => mapMentionToIdentity({
        id: mention?.mentionData?.id,
        // @ts-expect-error
        type: mention?.mentionData?.type,
    }))
        .filter(isDefined);
};
const mapMentionToIdentity = ({ id, type, }) => {
    if (!id) {
        return undefined;
    }
    return type && type === MentionType.GROUP ? { groupId: id } : { memberId: id };
};
//# sourceMappingURL=extract-mentions.js.map